import { isMobile } from '../../utils/validate'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  data () {
    const validateEmail = (rule, value, callback) => {
      if (!isMobile(value)) {
        callback(new Error('请输入正确的合法手机号'))
      } else {
        callback()
      }
    }
    const validatePass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'))
      } else {
        callback()
      }
    }
    const system = process.env.VUE_APP_PRODUCT_MODEL
    const brand = require(`@/assets/img/${system}/logo.jpg`)
    const login_bg = require(`@/assets/img/${system}/login_bg.jpg`)
    return {
      isAuto: false,
      isIframe: false,
      autoSrc: '',
      brand,
      login_bg,
      logining: false,
      ruleForm1: {
        account: '',
        checkPass: '',
        loginType: 'admin'
      },
      rules1: {
        account: [{ required: true, trigger: 'blur', validator: validateEmail }],
        checkPass: [{ required: true, trigger: 'blur', validator: validatePass }]
      },
      checked: true,
      submitDisabled: false,
      ifWindow: null,
      bool: false,
      beian: process.env.VUE_APP_BEIAN,
      status: process.env.VUE_APP_STATUS
    }
  },
  watch: {},
  mounted () {},
  methods: {
    ...mapMutations(['setTokenExp', 'setMenu', 'setUserInfo']),
    ...mapActions(['getPermission', 'getUserInfo', 'setToken']),
    tabChange (e) {
      this.ruleForm1.loginType = e.name
      this.ruleForm1.account = ''
      this.ruleForm1.checkPass = ''
    },
    handleSubmit1 () {
      this.$refs.ruleForm1.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.submitDisabled = true
          var params = {
            username: this.ruleForm1.account,
            password: this.ruleForm1.checkPass,
            logintype: this.ruleForm1.loginType
          }
          try {
            const { token } = await this.$api.auth.login(params)
            console.log(token, '登录接口的返回token')

            if (token) {
              sessionStorage.setItem('isLoaded', true)
            }

            this.setToken({ token })
            this.setTokenExp({ exp: new Date().getTime() })
            this.$message({
              message: '登录成功',
              type: 'success'
            })
            this.$router.push({ path: '/', replace: true })
          } catch (e) {
            this.submitDisabled = false
          }
        } else {
          this.submitDisabled = false
          return false
        }
      })
    }
  }
}
